import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Row, Col } from 'antd'

import SearchBar from './SearchBar'
import List from './List'

@inject((store: any) => {
    const { doctorsStore, popupStore } = store
    return { doctorsStore, popupStore }
})
@observer
class Doctors extends Component<any, any> {
    componentDidMount() {
        this.updateDoctors()
    }
    updateDoctors = async () => {
        const { doctorsStore } = this.props
        await doctorsStore.getDoctors()
    }
    render() {
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader onBack={() => window.history.back()} title="רופאים" />
                <Row>
                    <Col>
                        <SearchBar />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <List />
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default withRouter(Doctors)
